export const ProjectTypeType = {
	REGULAR: 'regular',
	RETAINER: 'retainer',
	INTERNAL: 'internal',
} as const;

export const DefaultRetainerFrequency = 1;
export const DefaultRetainerNoOfPeriods = 1;

export const RevenueTypeId = {
	SERVICE: '0',
	ROLES: '1',
} as const;

export const RevenueCalculations = [
	{
		id: '0',
		title: 'project_service_based_prices',
	},
	{
		id: '1',
		title: 'project_role_based_prices',
	},
];
